import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const auditService = createApi({
  reducerPath: "auditService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAudits: builder.query<
      any,
      { offset: number; limit: number; query: string; from?: string; to?: string }
    >({
      query: (params) => ({
        url: `/audits`,
        params: params,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success === true) {
          const data = rawData?.data?.messages?.map((item: any) => item.message);
          return { data, total: rawData?.data?.total_results };
        }
      },
    }),
    createAudit: builder.mutation<
      any,
      { page_name: string; old_value: string; new_value: string; type: string }
    >({
      query: (body: any) => ({
        url: "/audits",
        body,
        method: "POST",
      }),
    }),
    getMerchantAuditLogs: builder.query<
      { data: any[]; total: number; meta?: any },
      {
        merchantId: string;
        keyword?: string;
        module?: string;
        entityType?: string;
        event?: string;
        dateFrom?: string;
        dateTo?: string;
        sortBy?: string;
        order?: string;
        page?: number;
        limit?: number;
      }
    >({
      query: ({
        merchantId,
        keyword,
        module,
        entityType,
        event,
        dateFrom,
        dateTo,
        sortBy,
        order,
        page,
        limit,
      }) => {
        // Only send parameters the user actually set (empty filters are omitted).
        const params: Record<string, any> = { merchant_id: merchantId };
        if (keyword) params.keyword = keyword;
        if (module) params.module = module;
        if (entityType) params.entity_type = entityType;
        if (event) params.event = event;
        if (dateFrom) params.date_from = dateFrom;
        if (dateTo) params.date_to = dateTo;
        if (sortBy) params.sortBy = sortBy;
        if (order) params.order = order;
        if (page) params.page = page;
        if (limit) params.limit = limit;
        return { url: `/audit-logs`, params, method: "GET" };
      },
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          const data = rawData?.data ?? [];
          const meta = rawData?.meta;
          const total =
            meta?.total ??
            meta?.total_results ??
            meta?.total_records ??
            meta?.pagination?.total ??
            data.length;
          return { data, total, meta };
        }
        return { data: [], total: 0, meta: undefined };
      },
    }),
    getMerchantAuditLogDetail: builder.query<any, { id: string | number }>({
      query: ({ id }) => ({
        url: `/audit-logs/${id}`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => (rawData?.success ? rawData?.data : undefined),
    }),
  }),
});

export const {
  useGetAuditsQuery,
  useCreateAuditMutation,
  useGetMerchantAuditLogsQuery,
  useLazyGetMerchantAuditLogDetailQuery,
} = auditService;
